import { styled } from '@mui/material';
import theme from 'theme';

const PREFIX = 'CompGroupsOptions';

export const compGroupsOptionsClasses = {
  paper: `${PREFIX}-paper`,
  menuList: `${PREFIX}-menuList`,
  menuItem: `${PREFIX}-menuItem`,
};

export const CompGroupsOptionsRoot = styled('div')(() => ({
  position: 'absolute',
  right: 0,
  top: 0,
  [`& .${compGroupsOptionsClasses.paper}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },

  [`& .${compGroupsOptionsClasses.menuList}`]: {
    '& .MuiListItem-root': {
      textAlign: 'right',
      justifyContent: 'end',
      width: 'fit-content',
    },
    '& .MuiMenuItem-root': {
      marginLeft: 'auto',
      backgroundColor: '#037DE8',
      color: '#FFFFFF',
      margin: '0.8rem 0',
      borderRadius: theme.spacing(0.5),
      textTransform: 'uppercase',
      transition: 'background-color .15s cubic-bezier(.4,0,.2,1)',
    },
    '& .MuiMenuItem-root:hover': {
      backgroundColor: '#043A6E',
    },
  },

  [`& .${compGroupsOptionsClasses.menuItem}`]: {},
}));
